import { Button, Card, DatePicker, InputNumber, notification, Upload } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateRetreat } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import dayjs from "dayjs"
import { ArrowLeftOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import { useState } from "react"
const AdminAddRetreat = () => {
    const navigate = useNavigate()
    
    const [form] = Form.useForm();
    const onFinish = (values) => {
        console.log(values)
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('cost', values.cost);
        formData.append('capacity', values.capacity);
        formData.append('duration', values.duration);
        formData.append('description', values.description);
        formData.append('startDate', dayjs(values.startDate).format('YYYY-MM-DD'));

        values.retreatLearningOutcomes?.forEach(outcome => {
            formData.append('learningOutcome', JSON.stringify({
                title: outcome.title,
                subTitle: outcome.subTitle,
                description: outcome.description
            }));
        });

        if (values.images) {
            values.images.forEach((image, index) => {
                if (image.originFileObj) {
                    formData.append('images', image.originFileObj);
                }
            });
        }

        if (values.documents) {
            values.documents.forEach((doc, index) => {
                if (doc.originFileObj) {
                    formData.append('documents', doc.originFileObj);
                }
            });
        }

        CreateRetreat(formData).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Created Retreat Successfully"
                })
                setTimeout(navigate("/Admin/Retreat"), 2000);

            }
        }).catch(err => {
            console.log(err.response)
            notification.error({
                message: `${err.response.data.message}`
            })
        })
    }


    return (
        <div>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>
            <div style={{ maxWidth: 800, margin: 'auto', padding: '24' }}>
                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Create Retreat
                </Title>
                <Form
                    form={form}
                    onFinish={onFinish}
                    name="wrap"
                    labelAlign="left"
                    labelWrap
                    labelCol={{ flex: '150px' }}
                >
                    <Card title="Requirement Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                        <Form.Item name={"name"} label="Retreat Name" rules={[{ required: true, message: 'Requiring Retreat Name' }]}>
                            <Input
                                placeholder="Input Retreat Name"
                            />
                        </Form.Item>
                        <Form.Item name={"cost"} label="Tuition Fee($)" rules={[{ required: true, message: 'Requiring Tuition Fee' }]}>
                            <InputNumber min={1} style={{ width: '100%' }}
                                placeholder="Input Fee"
                            />
                        </Form.Item>
                        <Form.Item name={"capacity"} label="Capacity" rules={[{ required: true, message: 'Requiring capacity' }]}>
                            <InputNumber min={1} style={{ width: '100%' }}
                                placeholder="Input Capacity"
                            />
                        </Form.Item>
                        <Form.Item name={"duration"} label="Duration" rules={[{ required: true, message: 'Requiring duration' }]}>
                            <InputNumber min={1} style={{ width: '100%' }}
                                placeholder="Input Duration"
                            />
                        </Form.Item>
                        <Form.Item name={"startDate"} label="Start Date" rules={[{ required: true }]}>
                            <DatePicker placeholder="Select Start Date" />
                        </Form.Item>
                        <div style={{ marginBottom: 10, fontSize: 15 }}>Description</div>
                        <Form.Item name={"description"} rules={[{ required: true, message: 'Requiring Description' }]} >
                            <div style={{ height: '480px', marginBottom: 15 }}>
                                <ReactQuill
                                    onChange={(value) => {
                                        form.setFieldsValue({ description: value });
                                    }}
                                    placeholder="Input Description"
                                    modules={{
                                        toolbar: [
                                            ['bold', 'link', { list: 'ordered' }, { list: 'bullet' }],
                                            [{ 'header': [1, 2, false] }],
                                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                                            [{ 'direction': 'rtl' }],
                                            ['image']
                                        ]
                                    }}
                                    formats={[
                                        'bold', 'link', 'list', 'header', 'indent', 'direction', 'image'
                                    ]}
                                    style={{ height: '100%' }}
                                />
                            </div>
                        </Form.Item>
                    </Card>
                    <Card title="Image/Document" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                        <Form.Item
                            name="images"
                            label="Image"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => {
                                if (Array.isArray(e)) {
                                    return e;
                                }
                                return e?.fileList;
                            }}
                        >
                            <Upload
                                listType="picture-card"
                                maxCount={2}
                                beforeUpload={() => false}
                                accept="image/*"
                            >
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            </Upload>
                        </Form.Item>
                        <Form.Item name="documents"
                            label="Retreat Documents"
                            getValueFromEvent={(e) => {
                                console.log('Upload event:', e);
                                if (Array.isArray(e)) {
                                    return e;
                                }
                                return e?.fileList;
                            }}
                        >
                            <Upload
                                listType="text"
                                maxCount={2}
                                beforeUpload={() => false}
                                accept=".doc,.docx,.pdf"
                            >
                                <Button icon={<UploadOutlined />}>Upload Document</Button>
                            </Upload>
                        </Form.Item>
                    </Card>
                    <Form.List name="retreatLearningOutcomes">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <div key={key} style={{ marginBottom: 16, border: '1px solid #d9d9d9', padding: 16, borderRadius: 8 }}>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'title']}
                                            label="Title"
                                            rules={[{ required: true, message: 'Title is required' }]}
                                        >
                                            <Input placeholder="Enter title" />
                                        </Form.Item>

                                        <Form.Item
                                            {...restField}
                                            name={[name, 'subTitle']}
                                            label="Subtitle"
                                            rules={[{ required: true, message: 'Subtitle is required' }]}
                                        >
                                            <Input placeholder="Enter subtitle" />
                                        </Form.Item>

                                        <Form.Item
                                            {...restField}
                                            name={[name, 'description']}
                                            label="Description"
                                            rules={[{ required: true, message: 'Description is required' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Enter description" />
                                        </Form.Item>

                                        <Button type="link" danger onClick={() => remove(name)} icon={<MinusCircleOutlined />}>
                                            Remove this outcome
                                        </Button>
                                    </div>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                        Add Learning Outcome
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                    <Form.Item>
                        <Button block type="primary" htmlType="submit">
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )

}
export default AdminAddRetreat 